import React from 'react';

function Togo(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123984)">
        <mask
          id="mask0_800_123984"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123984)">
          <path
            d="M0 -1H-1V0V24V25H0H36H37V24V0V-1H36H0Z"
            fill="#5EAA22"
            stroke="#F7FCFF"
            strokeWidth="2"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 6V10H36V6H0Z"
            fill="#FECA00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 14V18H36V14H0Z"
            fill="#FECA00"
          />
          <rect width="18" height="14" fill="#F50101" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.28125 10.1442L5.09701 12.4456L6.72145 8.58206L3.375 5.97918H7.47876L9.28125 2.12982L10.6568 5.97918H14.7112L11.8636 8.58206L13.265 12.2561L9.28125 10.1442Z"
            fill="#F7FCFF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123984">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Togo;
